import React, { useEffect, useState, useRef } from "react";
import { createPortal } from "react-dom";
import { useSelector, useDispatch } from "react-redux";

import { getFlatsStatus, getFloorPlan, getRoomData } from "../../api/api";

import { changeActiveFloor, changeStep } from "../../store/visualSlice";

import GroundFloorPlan from "../../../../assets/floors/GroundFloorPlan";
import SecondFloorPlan from "../../../../assets/floors/SecondFloorPlan";
import ThirdFloorPlan from "../../../../assets/floors/ThirdFloorPlan";
import FourthFloorPlan from "../../../../assets/floors/FourthFloorPlan";
import FifthFloorPlan from "../../../../assets/floors/FifthFloorPlan";
import SixthFloorPlan from "../../../../assets/floors/SixthFloorPlan";
import SeventhFloorPlan from "../../../../assets/floors/SeventhFloorPlan";
import EighthFloorPlan from "../../../../assets/floors/EighthFloorPlan";

import Arrow from "../../../../assets/Arrow";
import Compass from "../../../../assets/Compass";

export const FlatsVisualStep = ({ complexId }) => {
	const [currentFloorTmp, setCurrentFloorTmp] = useState(null);
	const [selectedRoom, setSelectedRoom] = useState(null);
	const [floorPlans, setFloorPlans] = useState([]);
	const [tooltipData, setTooltipData] = useState({});
	const [tooltipShow, setTooltipShow] = useState(false);
	const [roomsStatus, setRoomsStatus] = useState();
	const [tooltipCoordinate, setTooltipCoordinate] = useState({});
	const [isLoading, setIsLoading] = useState(true);

	const { floors, activeFloor, activeSection } = useSelector(
		(state) => state.visual
	);
	const isEnglish = document.body.classList.contains("en");
	const windowWidth = window.innerWidth < 1440;

	const previewCache = {};

	const dispatch = useDispatch();
	const floor = useRef();
	const floorsToggle = useRef();
	const filter = useRef();
	const slider = useRef();
	const floorEight = useRef();

	let sliderInstance;
	let currentFloor;

	const main =
		location.href === "/projects/" + complexName + "/apartments/?type=visual";

	let floorsList = [];

	if (complexId == 43906) {
		floorsList = [1,2,3,4,5,6,7]
	} else {
		switch (activeSection) {
			case "a":
				floorsList = [1, 2, 3, 4, 5, 6]; // Этажи от 1 до 6
				break;
			case "b":
				floorsList = [1, 2, 3, 4, 5, 6, 7]; // Этажи от 1 до 7
				break;
			case "c":
				floorsList = [2, 3, 4, 5, 6, 7]; // Этажи от 2 до 7
				break;
			default:
				floorsList = []; // Если не подходит ни один случай
		}
	}
	floorsList = floorsList.reverse();

	const changeFloor = () => {
		if (!activeSection) {
			switch (activeFloor) {
				case "1":
					currentFloor = <GroundFloorPlan ref={floor} />;
					break;
				case "2":
					currentFloor = <SecondFloorPlan ref={floor} />;
					break;
				case "3":
					currentFloor = <ThirdFloorPlan ref={floor} />;
					break;
				case "4":
					currentFloor = <FourthFloorPlan ref={floor} />;
					break;
				case "5":
					currentFloor = <FifthFloorPlan ref={floor} />;
					break;
				case "6":
					currentFloor = <SixthFloorPlan ref={floor} />;
					break;
				case "7":
					currentFloor = <SeventhFloorPlan ref={floor} />;
					break;
				default:
					currentFloor = null;
					break;
			}
		} else {
			if (floorPlans[activeFloor]) {
				currentFloor = (
					<svg
						ref={floor}
						dangerouslySetInnerHTML={{ __html: floorPlans[activeFloor] }}
					/>
				);
			}

			if (currentFloorTmp) {
				currentFloor = currentFloorTmp;
			}
		}
	};

	const initTooltips = () => {
		if (floor.current && floor.current?.querySelector("g#appart")) {
			for (let flat of floor.current.querySelector("g#appart")?.childNodes) {
				flat.style && (flat.style.cursor = "pointer");

				flat.addEventListener("mouseenter", (evt) => {
					if (flat.classList.contains("sold")) {
						setTooltipData({ title: "sold" });
					} else if (flat.classList.contains("reserved")) {
						setTooltipData({ title: "reserved" });
					} else {
						setTooltipData({
							title: isEnglish
								? flat.getAttribute("data-info-en")
								: flat.getAttribute("data-info"),
						});
					}

					setTooltipShow(true);
				});

				flat.addEventListener("mousemove", (e) => {
					setTooltipCoordinate({ x: e.offsetX, y: e.offsetY });
				});

				flat.addEventListener("mouseleave", (e) => {
					setTooltipData({ title: "" });

					setTooltipShow(false);
				});

				flat.addEventListener("click", () => {
					if (!flat.classList.contains("free")) {
						return;
					}

					const apartId = flat.getAttribute("data-id");
					location.href = `/projects/${complexName}/apartments/${apartId}/`;
				});
			}
		}

		if (activeFloor === "7" && complexName == "essence") {
			for (let flat of floorEight.current.querySelector("g#appart")
				?.childNodes) {
				flat.style.cursor = "pointer";

				flat.addEventListener("mouseenter", (evt) => {
					setTooltipData({
						title: isEnglish
							? flat.getAttribute("data-info-en")
							: flat.getAttribute("data-info"),
					});

					setTooltipShow(true);
				});

				flat.addEventListener("mousemove", (e) => {
					setTooltipCoordinate({ x: e.offsetX, y: e.offsetY });
				});

				flat.addEventListener("mouseleave", (e) => {
					setTooltipData({ title: "" });

					setTooltipShow(false);
				});

				flat.addEventListener("click", () => {
					const apartId = flat.getAttribute("data-id");
					location.href = `/projects/essence/apartments/${apartId}/`;
				});
			}
		}
	};

	useEffect(() => {
		if (activeSection) {
			getFloorPlan({ sectionId: activeSection, floorNumber: 0 })
				.then((data) => {
					setFloorPlans(data);

					getFlatsStatus({ complexId, floorNumber: activeFloor }).then(
						(data) => {
							setRoomsStatus(data);
						}
					);
				})
				.finally(() => {
					setIsLoading(false);
				});
		} else {
			setIsLoading(false);
		}
	}, []);

	useEffect(() => {
		floorsToggle.current.childNodes.forEach((item) => {
			item.getAttribute("data-floor") === activeFloor
				? item.classList.add("active")
				: "";
		});

		if (!isLoading || complexName == "essence") {
			getFlatsStatus({ complexId, floorNumber: activeFloor }).then((data) => {
				setRoomsStatus(data);
			});

			filter.current.addEventListener("click", (evt) => {
				const target = evt.target;

				if (target.closest("li:not(.active)")) {
					const currentTarget = target.closest("li:not(.active)");
					const currentFlat = currentTarget.getAttribute("data-flat");

					filter.current.childNodes.forEach((item) =>
						item.classList.remove("active")
					);
					currentTarget.classList.add("active");

					if (currentFlat === "all") {
						floor.current
							.querySelectorAll("g#appart .disabled")
							?.forEach((item) => item.classList.remove("disabled"));
						if (activeFloor === "7" && complexName == "essence") {
							floorEight.current
								.querySelectorAll("g#appart .disabled")
								?.forEach((item) => item.classList.remove("disabled"));
						}
						return;
					}

					const cls1 = floor.current
						.querySelectorAll("g#appart .cls-1")
						?.forEach((item) => item.classList.add("disabled"));
					const cls3 = floor.current
						.querySelectorAll("g#appart .cls-3")
						?.forEach((item) => item.classList.add("disabled"));
					const cls4 = floor.current
						.querySelectorAll("g#appart .cls-4")
						?.forEach((item) => item.classList.add("disabled"));
					const cls6 = floor.current
						.querySelectorAll("g#appart .cls-6")
						?.forEach((item) => item.classList.add("disabled"));

					floor.current
						.querySelectorAll(`g#appart .${currentFlat}`)
						?.forEach((item) => item.classList.remove("disabled"));

					if (activeFloor === "7" && complexName == "essence") {
						floorEight.current
							.querySelectorAll("g#appart .cls-1")
							?.forEach((item) => item.classList.add("disabled"));
						floorEight.current
							.querySelectorAll("g#appart .cls-3")
							?.forEach((item) => item.classList.add("disabled"));
						floorEight.current
							.querySelectorAll("g#appart .cls-4")
							?.forEach((item) => item.classList.add("disabled"));
						floorEight.current
							.querySelectorAll("g#appart .cls-6")
							?.forEach((item) => item.classList.add("disabled"));

						floorEight.current
							.querySelectorAll(`g#appart .${currentFlat}`)
							?.forEach((item) => item.classList.remove("disabled"));
					}
				}
			});

			initTooltips();
		}

		if (activeFloor === "7" && complexName == "essence") {
			sliderInstance = new Swiper(slider.current, {
				slidesPerView: 1,
				spaceBetween: 50,
				loop: true,
				initialSlide: 0,
				pagination: {
					el: ".bullets",
					clickable: true,
					renderBullet: function (index, className) {
						return `<li class="${className}">${++index} этаж</li>`;
					},
				},
			});
		}

		() => {
			filter.current.removeEventListener("click", () => {});

			for (let flat of floor.current.querySelector("g#appart")?.childNodes) {
				flat.addEventListener("mouseenter", () => {});
				flat.addEventListener("mousemove", () => {});
				flat.addEventListener("mouseleave", () => {});
			}

			if (activeFloor === "7" && complexName == "essence") {
				for (let flat of floorEight.current.querySelector("g#appart")
					?.childNodes) {
					flat.addEventListener("mouseenter", () => {});
					flat.addEventListener("mousemove", () => {});
					flat.addEventListener("mouseleave", () => {});
				}
			}
		};
	}, []);

	useEffect(() => {
		if (!roomsStatus) {
			return;
		}

		if (floor.current.querySelector("g#appart")) {
			floor.current.querySelector("g#appart").childNodes.forEach((item) => {
				item.classList && item.classList.add(roomsStatus[item.dataset.id]);

				if (
					item.classList &&
					item.dataset &&
					roomsStatus[item.dataset.id] == "free" &&
					complexName != "essence"
				) {
					item.addEventListener("click", () => {
						const apartId = item.getAttribute("data-id");
						location.href = `/projects/${complexName}/apartments/${apartId}/`;
					});

					item.addEventListener("mouseenter", (evt) => {
						if (previewCache[item.dataset.id]) {
							setSelectedRoom(previewCache[item.dataset.id]);
						} else {
							getRoomData(item.dataset.id).then((data) => {
								setSelectedRoom(data);
								previewCache[data.id] = data;
							});
						}
					});
				}
			});

			if (activeFloor === "7" && complexName == "essence") {
				floorEight.current
					.querySelector("g#appart")
					.childNodes.forEach((item) => {
						item && item.classList.add(roomsStatus[item.dataset.id]);
					});
			}
		}
	}, [roomsStatus, activeFloor]);

	useEffect(() => {
		changeFloor();
		if (activeFloor) {
			setIsLoading(false);
		}

		if (!isLoading || complexName == "essence") {
			initTooltips();

			getFlatsStatus({ complexId, floorNumber: activeFloor }).then((data) => {
				setRoomsStatus(data);
			});
		}

		sliderInstance = new Swiper(slider.current, {
			slidesPerView: 1,
			spaceBetween: 50,
			loop: true,
			initialSlide: 0,
			pagination: {
				el: ".bullets",
				clickable: true,
				renderBullet: function (index, className) {
					return `<li class="${className}">${++index} этаж</li>`;
				},
			},
		});

		if (activeFloor !== "7" || complexName !== "essence") {
			sliderInstance.destroy(true);
		}

		filter.current.childNodes.forEach((item) => {
			if (item.getAttribute("data-flat") === "all") {
				item.classList.add("active");
			} else {
				item.classList.remove("active");
			}
		});
	}, [activeFloor]);

	changeFloor();

	const onChangeFloor = (e) => {
		const target = e.target;

		if (target.closest("li:not(.active)")) {
			const targetItem = target.closest("li:not(.active)");
			const floorNumber = targetItem.getAttribute("data-floor");

			dispatch(changeActiveFloor(floorNumber));

			floorsToggle.current.childNodes.forEach((item) =>
				item.classList.remove("active")
			);
			targetItem.classList.add("active");
		}
	};

	let complexNameTmp = document
		.querySelector("section.chooser")
		?.getAttribute("data-complex-name")
		.toLowerCase();

	const complexName =
		complexNameTmp == "bamboo forest" ? "bamboo-forest" : complexNameTmp;

	const showVisual = () => {
        const formattedName = complexName.replace(/\s+/g, '-');
	    location.href = "/projects/" + formattedName + "/apartments/";
	};

	const onBackStep = () => {
		dispatch(changeStep("floors"));
		dispatch(changeActiveFloor(""));
	};

	const filterOptions = {
		a: {
			1: [
				{
					value: "cls-3",
					label: isEnglish ? "1-bedroom" : "1-комн.",
					color: "#E3EF9C",
				},
			],
			2: [
				{
					value: "cls-3",
					label: isEnglish ? "1-bedroom" : "1-комн.",
					color: "#E3EF9C",
				},
			],
			2: [
				{
					value: "cls-3",
					label: isEnglish ? "1-bedroom" : "1-комн.",
					color: "#E3EF9C",
				},
				{
					value: "cls-4",
					label: isEnglish ? "2-bedroom" : "2-комн.",
					color: "#92AC6D",
				},
			],
			3: [
				{
					value: "cls-3",
					label: isEnglish ? "1-bedroom" : "1-комн.",
					color: "#E3EF9C",
				},
				{
					value: "cls-4",
					label: isEnglish ? "2-bedroom" : "2-комн.",
					color: "#92AC6D",
				},
			],
			4: [
				{
					value: "cls-3",
					label: isEnglish ? "1-bedroom" : "1-комн.",
					color: "#E3EF9C",
				},
				{
					value: "cls-4",
					label: isEnglish ? "2-bedroom" : "2-комн.",
					color: "#92AC6D",
				},
			],
			5: [
				{
					value: "cls-3",
					label: isEnglish ? "1-bedroom" : "1-комн.",
					color: "#E3EF9C",
				},
				{
					value: "cls-4",
					label: isEnglish ? "2-bedroom" : "2-комн.",
					color: "#92AC6D",
				},
			],
			6: [
				{
					value: "cls-3",
					label: isEnglish ? "1-bedroom" : "1-комн.",
					color: "#E3EF9C",
				},
				{
					value: "cls-4",
					label: isEnglish ? "2-bedroom" : "2-комн.",
					color: "#92AC6D",
				},
				{
					value: "cls-6",
					label: isEnglish ? "Duplex" : "Дуплекс",
					color: "#86AFB3",
				},
			],
		},
		b: {
			1: [
				{
					value: "cls-3",
					label: isEnglish ? "1-bedroom" : "1-комн.",
					color: "#E3EF9C",
				},
			],
			2: [
				{
					value: "cls-3",
					label: isEnglish ? "1-bedroom" : "1-комн.",
					color: "#E3EF9C",
				},
			],
			2: [
				{
					value: "cls-3",
					label: isEnglish ? "1-bedroom" : "1-комн.",
					color: "#E3EF9C",
				},
				{
					value: "cls-4",
					label: isEnglish ? "2-bedroom" : "2-комн.",
					color: "#92AC6D",
				},
			],
			3: [
				{
					value: "cls-3",
					label: isEnglish ? "1-bedroom" : "1-комн.",
					color: "#E3EF9C",
				},
				{
					value: "cls-4",
					label: isEnglish ? "2-bedroom" : "2-комн.",
					color: "#92AC6D",
				},
			],
			4: [
				{
					value: "cls-3",
					label: isEnglish ? "1-bedroom" : "1-комн.",
					color: "#E3EF9C",
				},
				{
					value: "cls-4",
					label: isEnglish ? "2-bedroom" : "2-комн.",
					color: "#92AC6D",
				},
			],
			5: [
				{
					value: "cls-3",
					label: isEnglish ? "1-bedroom" : "1-комн.",
					color: "#E3EF9C",
				},
				{
					value: "cls-4",
					label: isEnglish ? "2-bedroom" : "2-комн.",
					color: "#92AC6D",
				},
			],
			6: [
				{
					value: "cls-3",
					label: isEnglish ? "1-bedroom" : "1-комн.",
					color: "#E3EF9C",
				},
				{
					value: "cls-4",
					label: isEnglish ? "2-bedroom" : "2-комн.",
					color: "#92AC6D",
				},
				{
					value: "cls-6",
					label: isEnglish ? "Duplex" : "Дуплекс",
					color: "#86AFB3",
				},
			],
			7: [
				{
					value: "cls-4",
					label: isEnglish ? "2-bedroom" : "2-комн.",
					color: "#92AC6D",
				},
			],
		},
		c: {
			2: [
				{
					value: "cls-3",
					label: isEnglish ? "1-bedroom" : "1-комн.",
					color: "#E6EDD9",
				},
				{
					value: "cls-4",
					label: isEnglish ? "2-bedroom" : "2-комн.",
					color: "#92AC6D",
				},
			],
			3: [
				{
					value: "cls-3",
					label: isEnglish ? "1-bedroom" : "1-комн.",
					color: "#E6EDD9",
				},
				{
					value: "cls-4",
					label: isEnglish ? "2-bedroom" : "2-комн.",
					color: "#92AC6D",
				},
			],
			4: [
				{
					value: "cls-3",
					label: isEnglish ? "1-bedroom" : "1-комн.",
					color: "#E6EDD9",
				},
				{
					value: "cls-4",
					label: isEnglish ? "2-bedroom" : "2-комн.",
					color: "#92AC6D",
				},
			],
			5: [
				{
					value: "cls-3",
					label: isEnglish ? "1-bedroom" : "1-комн.",
					color: "#E6EDD9",
				},
				{
					value: "cls-4",
					label: isEnglish ? "2-bedroom" : "2-комн.",
					color: "#92AC6D",
				},
			],
			6: [
				{
					value: "cls-3",
					label: isEnglish ? "1-bedroom" : "1-комн.",
					color: "#E6EDD9",
				},
				{
					value: "cls-4",
					label: isEnglish ? "2-bedroom" : "2-комн.",
					color: "#92AC6D",
				},
			],
			7: [
				{
					value: "cls-3",
					label: isEnglish ? "1-bedroom" : "1-комн.",
					color: "#E6EDD9",
				},
				{
					value: "cls-4",
					label: isEnglish ? "2-bedroom" : "2-комн.",
					color: "#92AC6D",
				},
			],
		},
	};

	const renderFilters = () => {
		if (complexName === "essence") {
			return (
				<ul ref={filter}>
					<li className="active" data-flat="all">
						<button>Все</button>
					</li>
					<li data-flat="cls-1">
						<button>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="16"
								height="16"
								viewBox="0 0 16 16"
								fill="none"
							>
								<circle cx="8" cy="8" r="5" fill="#6CB1D3" />
							</svg>
							{isEnglish ? "Studio" : "Студия"}
						</button>
					</li>
					<li data-flat="cls-3">
						<button>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="16"
								height="16"
								viewBox="0 0 16 16"
								fill="none"
							>
								<circle cx="8" cy="8" r="5" fill="#CCECFF" />
							</svg>
							{isEnglish ? "1 room" : windowWidth ? "1-комн." : "1-спальный"}
						</button>
					</li>
					{activeFloor !== "1" && complexName == "essense" && (
						<>
							<li data-flat="cls-4">
								<button>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="16"
										height="16"
										viewBox="0 0 16 16"
										fill="none"
									>
										<circle cx="8" cy="8" r="5" fill="#0E7AA5" />
									</svg>
									{isEnglish
										? "2 rooms"
										: windowWidth
										? "2-комн."
										: "2-спальный"}
								</button>
							</li>
							{activeFloor == "7" && (
								<li data-flat="cls-6">
									<button>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="16"
											height="16"
											viewBox="0 0 16 16"
											fill="none"
										>
											<circle cx="8" cy="8" r="5" fill="#52A964" />
										</svg>
										{isEnglish ? "Duplex" : "Дуплекс"}
									</button>
								</li>
							)}
						</>
					)}
				</ul>
			);
		} else {
			return (
				<ul ref={filter}>
					<li className="active" data-flat="all">
						<button>{isEnglish ? "All" : "Все"}</button>
					</li>
					{filterOptions[activeSection][activeFloor].map((option) => (
						<li key={option.value} data-flat={option.value}>
							<button>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="16"
									height="16"
									viewBox="0 0 16 16"
									fill="none"
								>
									<circle cx="8" cy="8" r="5" fill={option.color} />
								</svg>
								{option.label}
							</button>
						</li>
					))}
				</ul>
			);
		}
	};

	return (
		<div className="visual-flats">
			<header>
				<>{renderFilters()}</>
				{/* <button
					className="chooser-type dark stroke"
					onClick={showVisual}
					type="button"
				>
					{isEnglish ? "Select by list" : "Выбрать списком"}
				</button> */}
				<button className="back" onClick={onBackStep}>
					{isEnglish ? "Close" : "Закрыть"}
					<span></span>
				</button>
			</header>
			<div>
				{complexId == 48351 ? (
					<span className="compass">
						<Compass />
					</span>
				) : null}
				<div className="around">
					<div className="wrapper">
						<span className="pier">
							<Arrow />
							{isEnglish ? "Pier" : "Пирс"} Chalong
						</span>
						<span className="sea">
							{isEnglish ? "Sea" : "Море"}
							<Arrow />
						</span>
						<span className="ravai">
							<Arrow />
							{isEnglish ? "Rawai" : "Равай"}
						</span>
						<span className="mountains">
							<Arrow />
							{isEnglish ? "Mountains" : "Горы"}
						</span>
						<span className="compass">
							<Compass />
						</span>
					</div>
				</div>
				<div ref={slider} className="slider swiper">
					<ul className="slides swiper-wrapper">
						<li className="swiper-slide">
							<picture>{currentFloor && currentFloor}</picture>
						</li>
						{activeFloor === "7" && complexName == "essence" ? (
							<li className="swiper-slide">
								<picture>
									<EighthFloorPlan ref={floorEight} />
								</picture>
							</li>
						) : null}
					</ul>
					{activeFloor === "7" && complexName == "essence" ? (
						<ul className="bullets"></ul>
					) : null}
					{activeFloor === "7" && complexName == "essence" ? (
						<div
							className="tooltip"
							style={{
								transform: `translateX(${
									tooltipCoordinate.x > 500 &&
									tooltipData.title !== "sold" &&
									tooltipData.title !== "reserved"
										? tooltipCoordinate.x - 200
										: tooltipData.title == "sold" ||
										  tooltipData.title == "reserved"
										? tooltipCoordinate.x - 100
										: tooltipCoordinate.x - 45
								}px) translateY(${
									tooltipCoordinate.y < 50
										? tooltipCoordinate.y + 75
										: tooltipCoordinate.y + 10
								}px)`,
								display: `${tooltipShow ? "block" : "none"}`,
								zIndex: 5,
							}}
						>
							{tooltipData.title}
						</div>
					) : activeFloor === "1" ? (
						<div
							className="tooltip"
							style={{
								transform: `translateX(${
									tooltipCoordinate.x > 500 &&
									tooltipData.title !== "sold" &&
									tooltipData.title !== "reserved"
										? tooltipCoordinate.x - 200
										: tooltipData.title == "sold" ||
										  tooltipData.title == "reserved"
										? tooltipCoordinate.x - 100
										: tooltipCoordinate.x - 45
								}px) translateY(${
									tooltipCoordinate.y < 50
										? tooltipCoordinate.y + 40
										: tooltipCoordinate.y - 20
								}px)`,
								display: `${tooltipShow ? "block" : "none"}`,
                                zIndex: 3,
							}}
						>
							{tooltipData.title}
						</div>
					) : (
						<div
							className="tooltip"
							style={{
								transform: `translateX(${
									tooltipCoordinate.x > 500 &&
									tooltipData.title !== "sold" &&
									tooltipData.title !== "reserved"
										? tooltipCoordinate.x - 200
										: tooltipData.title == "sold" ||
										  tooltipData.title == "reserved"
										? tooltipCoordinate.x - 100
										: tooltipCoordinate.x - 45
								}px) translateY(${
									tooltipCoordinate.y < 50
										? tooltipCoordinate.y + 90
										: tooltipCoordinate.y + 30
								}px)`,
								display: `${tooltipShow ? "block" : "none"}`,
                                zIndex: 3,
							}}
						>
							{tooltipData.title}
						</div>
					)}
				</div>
				<ul className="floors" onClick={onChangeFloor} ref={floorsToggle}>
					{floorsList.map((floorItem) => (
						<li key={floorItem} data-floor={floorItem}>
							<button>
								{floorItem} {isEnglish ? "floor" : "этаж"}
							</button>
						</li>
					))}
				</ul>
				{selectedRoom && (
					<RoomPreview room={selectedRoom} complexName={complexName} />
				)}
			</div>
			<button
				className="chooser-type dark stroke"
				onClick={showVisual}
				type="button"
			>
				{isEnglish ? "Select by list" : "Выбрать списком"}
			</button>
			{main ? (
				createPortal(<StubContent showVisual={showVisual} />, document.body)
			) : (
				<StubContent showVisual={showVisual} />
			)}
		</div>
	);
};

const RoomPreview = ({ room, complexName }) => {
	const [roomPreviewCache, setRoomPreviewCache] = useState({});

	const isEnglish = document.body.classList.contains("en");
	let price = room.prices.total.value.toLocaleString("ru-RU");

	let preview = (
		<div className="preview">
			<h3>
				{room.properties.rooms_count.value}-{isEnglish ? "room" : "спальный"},{" "}
				{complexName === "bamboo-forest"
					? room.layout.areas.total.value
					: room.layout.areas.full.value}{" "}
				{isEnglish ? "sq. m." : "м²"}
			</h3>
			<p>{price}&thinsp;฿</p>
			<picture>
				<img src={room.layout.properties.image.value} />
			</picture>
		</div>
	);
    console.log(room.enabled);
    if (!room.enabled) {
        preview = <div></div>
    }

	if (!roomPreviewCache[room.id]) {
		roomPreviewCache[room.id] = preview;
	}

	return roomPreviewCache[room.id] || preview;
};

const StubContent = ({ showVisual }) => {
	const isEnglish = document.body.classList.contains("en");

	return (
		<div className="stub">
			<div>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="93"
					height="85"
					viewBox="0 0 93 85"
					fill="none"
				>
					<g clipPath="url(#clip0_2190_23716)">
						<path
							d="M47 33V23.95C47 21.1969 47 19.8204 46.4727 18.7651C45.9888 17.7965 45.2035 17.0112 44.2349 16.5273C43.1796 16 41.8031 16 39.05 16H8.95C6.1969 16 4.82035 16 3.76511 16.5273C2.79654 17.0112 2.01124 17.7965 1.52728 18.7651C1 19.8204 1 21.1969 1 23.95V76.05C1 78.8031 1 80.1796 1.52728 81.2349C2.01124 82.2035 2.79654 82.9888 3.76511 83.4727C4.82035 84 6.1969 84 8.95 84H19"
							stroke="#F9FAFA"
							strokeWidth="2"
							strokeMiterlimit="10"
							strokeLinecap="square"
						/>
						<path
							d="M87 50V65"
							stroke="#F0F0F2"
							strokeWidth="2"
							strokeMiterlimit="10"
							strokeLinecap="square"
						/>
						<path
							d="M87 70V72"
							stroke="#F0F0F2"
							strokeWidth="2"
							strokeMiterlimit="10"
							strokeLinecap="square"
						/>
						<path
							d="M84.05 38C86.8031 38 88.1796 38 89.2349 38.5273C90.2035 39.0112 90.9888 39.7965 91.4727 40.7651C92 41.8204 92 43.1969 92 45.95V76.05C92 78.8031 92 80.1796 91.4727 81.2349C90.9888 82.2035 90.2035 82.9888 89.2349 83.4727C88.1796 84 86.8031 84 84.05 84H31.95C29.1969 84 27.8204 84 26.7651 83.4727C25.7965 82.9888 25.0112 82.2035 24.5273 81.2349C24 80.1796 24 78.8031 24 76.05V45.95C24 43.1969 24 41.8204 24.5273 40.7651C25.0112 39.7965 25.7965 39.0112 26.7651 38.5273C27.8204 38 29.1969 38 31.95 38H84.05Z"
							stroke="#F0F0F2"
							strokeWidth="2"
							strokeMiterlimit="10"
							strokeLinecap="square"
						/>
						<path
							d="M25 10C25 7.20435 25 5.80653 25.4567 4.7039C26.0657 3.23373 27.2337 2.06569 28.7039 1.45672C29.8065 1 31.2044 1 34 1H53.96C57.2637 1 58.9156 1 60.1819 1.63273C61.3442 2.21349 62.2865 3.15585 62.8673 4.31813C63.5 5.58442 63.5 7.23628 63.5 10.54V30"
							stroke="#F0F0F2"
							strokeWidth="2"
							strokeMiterlimit="10"
							strokeLinecap="square"
						/>
						<path
							d="M58 25.4854L63.6569 31.1422L69.3137 25.4854"
							stroke="#F0F0F2"
							strokeWidth="2"
							strokeMiterlimit="10"
							strokeLinecap="square"
						/>
					</g>
					<defs>
						<clipPath id="clip0_2190_23716">
							<rect width="93" height="85" fill="white" />
						</clipPath>
					</defs>
				</svg>
				<p>
					{isEnglish
						? "Rotate the device horizontally to select on the plan."
						: "Поверните устройство в\u00A0горизонтальное положение для\u00A0выбора на\u00A0плане"}
				</p>
			</div>
			<p>
				{isEnglish
					? "or select apartments according to parameters"
					: "или подберите апартаменты по параметрам"}
			</p>
			<button
				className="chooser-type dark stroke"
				onClick={showVisual}
				type="button"
			>
				{isEnglish ? "Select by list" : "Выбрать списком"}
			</button>
		</div>
	);
};
